const she = {
  FORMAT_ERROR: {
    message: 'Sheet is not in the standard format'
  },
  WRONG_NUMBER_OF_SHEETS: {
    message: 'Sheet must contain only one tab'
  },
  WRONG_FIRST_LINE: {
    message: 'First line is different from standard format'
  },
  HEADERS_LENGTH_ERROR_MESSAGE: {
    message: 'Header length is different from standard format'
  },
  HEADER_NOT_MAPPED: {
    message: 'One or more headers are not mapped'
  },
  REQUIRED_HEADER_NOT_PROVIDED: {
    message: 'One or more required headers were not provided'
  },
  UNABLE_TO_PROCESS_FILE: {
    message: 'Unable to process file'
  },
  INVALID_FILE_EXTENSION: {
    message: 'The file extension is not valid'
  }
};

module.exports = she;
